import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { iconFor } from "@/lib/data";

export const ServiceCard = ({ s, i = 0, city }) => {
  const Icon = iconFor(s.slug);
  return (
    <Link
      to={`/services/${s.slug}${city ? `/${city.slug}` : ""}`}
      data-testid={`service-card-${s.slug}`}
      className="group card-soft lift p-5 flex flex-col gap-4 fade-up"
      style={{ animationDelay: `${Math.min(i, 12) * 0.03}s` }}
    >
      <span className="h-12 w-12 rounded-2xl bg-secondary grid place-items-center group-hover:bg-primary transition-colors">
        <Icon className="h-6 w-6 text-primary group-hover:text-primary-foreground transition-colors" />
      </span>
      <div className="flex-1">
        <h3 className="font-semibold leading-tight">{s.name}{city ? ` in ${city.name}` : ""}</h3>
        <p className="mt-1 text-xs text-muted-foreground">{s.category}</p>
      </div>
      <span className="text-xs font-semibold text-primary inline-flex items-center gap-1">Book now <ArrowUpRight className="h-3.5 w-3.5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" /></span>
    </Link>
  );
};

export const ServicesGrid = ({ services, more = true, city }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4" data-testid="services-grid">
    {services.map((s, i) => <ServiceCard key={s.slug} s={s} i={i} city={city} />)}
    {more && (
      <Link to="/contact" data-testid="service-card-and-more" className="card-soft lift p-5 flex flex-col justify-center items-start gap-2 bg-primary text-primary-foreground border-primary">
        <span className="font-display text-2xl font-bold">And More</span>
        <span className="text-sm opacity-90">Can't find your service? Talk to us.</span>
      </Link>
    )}
  </div>
);
